export const LOAD_REF_DATA = 'LOAD_REF_DATA';

export function loadRefData(data) {
  return { type: LOAD_REF_DATA, data };
}
